import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_view_users",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-13" }, [
  /*#__PURE__*/_createVNode("h1", { class: "mb-3" }, "Browse Users"),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-5" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out our "),
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Users Directory"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_9 = { class: "mb-15" }
const _hoisted_10 = { class: "mh-375px scroll-y me-n7 pe-7" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_13 = { class: "ms-6" }
const _hoisted_14 = {
  href: "#",
  class: "\n                          d-flex\n                          align-items-center\n                          fs-5\n                          fw-bolder\n                          text-dark text-hover-primary\n                        "
}
const _hoisted_15 = { class: "badge badge-light fs-8 fw-bold ms-2" }
const _hoisted_16 = { class: "fw-bold text-gray-400" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "fs-5 fw-bolder text-dark" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted" }, "Sales", -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-between\"><div class=\"fw-bold\"><label class=\"fs-6\">Adding Users by Team Members</label><div class=\"fs-7 text-gray-400\"> If you need more info, please check budget planning </div></div><label class=\"form-check form-switch form-check-custom form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" checked=\"checked\"><span class=\"form-check-label fw-bold text-gray-400\"> Allowed </span></label></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "\n                    d-flex\n                    flex-stack\n                    py-5\n                    border-bottom border-gray-300 border-bottom-dashed\n                  "
                }, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      (user.avatar)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: user.avatar
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock("span", {
                            key: 1,
                            class: [`bg-light-${user.state} text-${user.state}`, "symbol-label fw-bold"]
                          }, _toDisplayString(user.name.charAt(0)), 3))
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("a", _hoisted_14, [
                        _createTextVNode(_toDisplayString(user.name) + " ", 1),
                        _createVNode("span", _hoisted_15, _toDisplayString(user.position), 1)
                      ]),
                      _createVNode("div", _hoisted_16, _toDisplayString(user.email), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, " $" + _toDisplayString(user.sales), 1),
                      _hoisted_20
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_21
        ])
      ])
    ])
  ]))
}